import { useMemo } from 'react';

import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { Link as LinkDesignSystem } from '@hivebrite/design-system/Link';

import AboutScreenReader from 'hb-react/frontoffice/apps/LiveFeed/components/AboutScreenReader';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { type Event } from 'hb-react/shared/apps/Events';
import { getEventDedicatedPath } from 'hb-react/shared/apps/Events/utils/getEventDedicatedUrl';

export const EventLink = ({
  event,
  as = 'Link',
  mt = 1,
}: {
  as?: 'Button' | 'Link';
  event: Pick<Event, 'id' | 'title' | 'type'>;
  mt?: number;
}) => {
  const { currentUser } = useDefaultAppContexts();
  const topicContext = useTopicContext();

  const eventDetailsPageLink = useMemo(
    () =>
      getEventDedicatedPath({
        hasUser: !!currentUser?.id,
        event: {
          ...event,
          type:
            event.type === 'network-event'
              ? 'network_events_event'
              : event.type,
        },
        topicId: topicContext?.topicId,
        isWhitelabelGroup: !!topicContext?.whitelabelURL,
      }),
    [currentUser, event, topicContext],
  );

  if (as === 'Button') {
    return (
      <ButtonInLink mt={mt} linkProps={{ to: eventDetailsPageLink }}>
        {__('Find out more')}
        {event.title && <AboutScreenReader name={event.title} />}
      </ButtonInLink>
    );
  }

  return (
    <LinkDesignSystem mt={mt} to={eventDetailsPageLink}>
      {__('Find out more')}
      {event.title && <AboutScreenReader name={event.title} />}
    </LinkDesignSystem>
  );
};
